module.exports = __webpack_public_path__ + "img/qr.6dd86c36.jpg";